import { render, staticRenderFns } from "./UpdateBusinessMemberEmail.vue?vue&type=template&id=37a617ca"
import script from "./UpdateBusinessMemberEmail.vue?vue&type=script&lang=js"
export * from "./UpdateBusinessMemberEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports